import { get, post } from "@/utils/utils";

const officialAccounts = {
  state: {
    wechatReqParams: []
  },
  mutations: {
    QUERY_WECHAT_REQ_PARAMS(state, data) {
      state.wechatReqParams = data.result;
    },
    POST_AUTH_CODE() {},
    QUERY_OA_AUTH_INFO() {},
    QUERY_OA_MENU() {},
    SAVE_OA_MENU() {},
    QUERY_REPLY_LIST() {},
    ADD_REPLT() {},
    EDIT_REPLY() {},
    QUERY_REPLY_DETAIL() {},
    SWITCH_REPLY_STATUS() {},
    QUERY_QRCODE_LIST() {},
    ADD_QRCODE() {},
    EDIT_QRCODE() {},
    QUERY_KEYWORD_LSIT() {},
    REMOVE_QRCODE() {},
    QUERY_CURRENT_QRCODE() {},
    SAVE_MINI_SCAN() {},
    USE_ACCESS_WE_CHAT_SHOP() {},
    USE_ACCESS_WE_CHAT_SHOP_SECEND() {},
    CHECK_USE_ACCESS_WE_CHAT_SHOP_SECEND() {},
    WX_TEMPLATE_GET_CATEGORY() {},
    GET_PUB_TEMPLATE_LISR() {},
    GET_PUB_TEMPLATE_BY_ID() {},
    ADD_WX_GZH_TEMPLATE() {},
    GET_MY_WX_GZH_TEMPLATE() {},
    QUERY_STORE_MINIPROGRAM_SCAN() {},
    CREATE_SHOP() {},
    QUERY_SHOP() {},
    UPDATE_SHOP() {},
  },
  actions: {
    queryCurrentQrcode({ commit }, params) {
      return post({
        commit,
        url: `/storeCouponSend/createCouponQrCode`,
        name: "QUERY_CURRENT_QRCODE",
        params
      });
    },
    removeQrcode({ commit }, params) {
      return get({
        commit,
        url: `/wxQr/delete`,
        name: "REMOVE_QRCODE",
        params
      });
    },
    addQrcode({ commit }, params) {
      return post({
        commit,
        url: `/wxQr/add`,
        name: "ADD_QRCODE",
        params
      });
    },
    queryKeywordList({ commit }, params) {
      return post({
        commit,
        url: `/wxKeyWord/findKeyWord`,
        name: "QUERY_KEYWORD_LSIT",
        params
      });
    },
    editQrcode({ commit }, params) {
      return post({
        commit,
        url: `/wxQr/edit`,
        name: "EDIT_QRCODE",
        params
      });
    },
    queryQrcodeList({ commit }, params) {
      return post({
        commit,
        url: `/middle/storeGuiderFollowupRecord/queryStoreMiniprogramScanList`,
        name: "QUERY_QRCODE_LIST",
        params
      });
    },
    switchReplyStatus({ commit }, params) {
      return get({
        commit,
        url: `/wxKeyWordRule/updateStatus`,
        name: "SWITCH_REPLY_STATUS",
        params
      });
    },
    queryReplyDetail({ commit }, params) {
      return get({
        commit,
        url: `/wxKeyWordRule/queryById`,
        name: "QUERY_REPLY_DETAIL",
        params
      });
    },
    editReply({ commit }, params) {
      return post({
        commit,
        url: `/wxKeyWordRule/edit`,
        name: "EDIT_REPLY",
        params
      });
    },
    addReply({ commit }, params) {
      return post({
        commit,
        url: `/wxKeyWordRule/add`,
        name: "ADD_REPLT",
        params
      });
    },
    queryReplyList({ commit }, params) {
      return post({
        commit,
        url: `/wxKeyWordRule/list`,
        name: "QUERY_REPLY_LIST",
        params
      });
    },
    saveOaMenu({ commit }, params) {
      return post({
        commit,
        url: `/wxMenu/edit`,
        name: "SAVE_OA_MENU",
        params
      });
    },
    queyOaMenu({ commit }, params) {
      return post({
        commit,
        url: `/wxMenu/list`,
        name: "QUERY_OA_MENU",
        params
      });
    },
    queryWechatReqParams({ commit }, params) {
      return get({
        commit,
        url: `/wxOpenPlantForm/queryWxOpenPlantForm`,
        name: "QUERY_WECHAT_REQ_PARAMS",
        params
      });
    },
    postAuthCode({ commit }, params) {
      return get({
        commit,
        url: `/authorizationInfo/wxAuthCode`,
        name: "POST_AUTH_CODE",
        params
      });
    },
    queryOaAuthInfo({ commit }, params) {
      return get({
        commit,
        url: `/authorizationInfoBack/findWxAuth`,
        name: "QUERY_OA_AUTH_INFO",
        params
      });
    },
    saveStoreMiniprogramScan({ commit }, params) {
      return post({
        commit,
        url: `/middle/storeGuiderFollowupRecord/saveStoreMiniprogramScan`,
        name: "SAVE_MINI_SCAN",
        params
      });
    },
    useAccessWeChatShop({ commit }, params) {
      return post({
        commit,
        url: `/basic/wxshopspu/useAccessWeChatShop`,
        name: "USE_ACCESS_WE_CHAT_SHOP",
        params
      });
    },
    useAccessWeChatShopSecend({ commit }, params) {
      return post({
        commit,
        url: `/basic/wxshopspu/useAccessWeChatShopSecend`,
        name: "USE_ACCESS_WE_CHAT_SHOP_SECEND",
        params
      });
    },
    checkUseAccessWeChatShopFirst({ commit }, params) {
      return post({
        commit,
        url: `/basic/wxshopspu/checkUseAccessWeChatShopFirst`,
        name: "CHECK_USE_ACCESS_WE_CHAT_SHOP_SECEND",
        params
      });
    },
    wxTemplateGetCategory({ commit }, params) {
      return post({
        commit,
        url: `/storeWxTemplate/getCategory`,
        name: "WX_TEMPLATE_GET_CATEGORY",
        params
      });
    },
    getPubTemplateTitleList({ commit }, params) {
      return post({
        commit,
        url: `/storeWxTemplate/getPubTemplateTitleList`,
        name: "GET_PUB_TEMPLATE_LISR",
        params
      });
    },
    getPubTemplateKeyWordsById({ commit }, params) {
      return post({
        commit,
        url: `/storeWxTemplate/getPubTemplateKeyWordsById`,
        name: "GET_PUB_TEMPLATE_BY_ID",
        params
      });
    },
    addWxGzhTemplate({ commit }, params) {
      return post({
        commit,
        url: `/storeWxTemplate/addTemplate`,
        name: "ADD_WX_GZH_TEMPLATE",
        params
      });
    },
    getMyTemplateList({ commit }, params) {
      return post({
        commit,
        url: `/storeWxTemplate/getTemplateList`,
        name: "GET_MY_WX_GZH_TEMPLATE",
        params
      });
    },
    queryStoreMiniprogramScan({ commit }, params) {
      return post({
        commit,
        url: `/middle/storeGuiderFollowupRecord/queryStoreMiniprogramScan`,
        name: "QUERY_STORE_MINIPROGRAM_SCAN",
        params
      });
    },
    createShop({ commit }, params) {
      return post({
        commit,
        url: `/authorizationInfoBack/mini/shop/create`,
        name: "CREATE_SHOP",
        params
      });
    },
    queryShop({ commit }, params) {
      return post({
        commit,
        url: `/authorizationInfoBack/mini/shop/query`,
        name: "QUERY_SHOP",
        params
      });
    },
    updateShop({ commit }, params) {
      return post({
        commit,
        url: `/authorizationInfoBack/mini/shop/update`,
        name: "UPDATE_SHOP",
        params
      });
    },
  }
};

export default officialAccounts;
